import { authenticatedGet, authenticatedPost, authenticatedPut } from "../../api/authenticatedFetch";

const BASE_API = "/api/v1/application-parameters";

export const getApplicationParameters = async () => authenticatedGet(BASE_API);

export const updateApplicationParameter = async (key, value) =>
  authenticatedPut(`${BASE_API}/${key}`, { value });

// Anthropic exec-summary key (platform-wide, write-only secret). The status endpoint only
// reports whether a key is configured — the value is never returned.
export const getAnthropicKeyStatus = async () =>
  authenticatedGet(`${BASE_API}/secrets/anthropic-key`);

export const setAnthropicKey = async (value) =>
  authenticatedPut(`${BASE_API}/secrets/anthropic-key`, { value });

// clearDashboardCache drops this tenant's cached dashboard payloads so the next dashboard load
// recomputes. Returns { cleared } — the row count, which is what tells an operator chasing a
// stale figure whether there was anything to clear at all.
export const clearDashboardCache = async () =>
  authenticatedPost(`${BASE_API}/dashboard-cache/clear`);
